import React from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
} from "@mui/material";

const ProjectsSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        maxWidth: 1200,
        mx: "auto",
        py: 6,
        px: 2,
      }}
    >
      <Grid container spacing={8}>
        {/* First Project Section */}
        <Grid item xs={12} md={6}>
          <Box textAlign="center">
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: isMobile ? "28px" : "46px",
                color: "#008037",
                mb: 2,
              }}
            >
              OUR NEW PROJECT - KALPAVRUKSHA GREEN
            </Typography>

            <Typography
              sx={{
                fontWeight: 700,
                fontSize: isMobile?"18px":"22px",
                mb: 1,
                color: "#000",
              }}
            >
              NAVA KARNATAKA NIRMANA & OTHERS HOUSING WELFARE TRUST
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "#333",
                lineHeight: 1.8,
                maxWidth: 600,
                mx: "auto",
                mb: 3,
              }}
            >
              Kalpavruksha Green is our latest premium township project designed
              for those who seek a perfect balance between modern living and
              natural tranquility. Located in Bengaluru’s fastest-growing
              corridor, this project offers well-planned plots surrounded by
              lush greenery and superior infrastructure. It’s not just a
              property — it’s an investment in a sustainable lifestyle and a
              bright future.
            </Typography>

            <Button
              variant="outlined"
              sx={{
                borderColor: "#008037",
                color: "#008037",
                fontWeight: 600,
                textTransform: "uppercase",
                "&:hover": {
                  backgroundColor: "#008037",
                  color: "#fff",
                  borderColor: "#008037",
                },
              }}
            >
              Download Brochure
            </Button>
          </Box>
        </Grid>

        {/* Second Project Section */}
        <Grid item xs={12} md={6}>
          <Box textAlign="center">
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: isMobile ? "28px" : "46px",
                color: "#b5651d",
                mb: 2,
              }}
            >
              CLOSED PROJECT - VAIBHAVA GREENS
            </Typography>

            <Typography
              sx={{
                fontWeight: 700,
                fontSize: isMobile ? "18px" : "22px",
                mb: 1,
                color: "#000",
              }}
            >
              NAVA KARNATAKA NIRMANA & OTHERS HOUSING WELFARE TRUST
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "#333",
                lineHeight: 1.8,
                maxWidth: 600,
                mx: "auto",
                mb: 3,
              }}
            >
              Vaibhava Greens stands as a testament to our commitment to quality
              and trust. This successfully completed project offered beautifully
              developed plots and a peaceful community environment in the heart
              of Bengaluru’s growth zone. With all units sold out, it continues
              to symbolize a vibrant and satisfied neighborhood built on
              reliability, transparency, and value for money.
            </Typography>

            <Button
              variant="outlined"
              sx={{
                borderColor: "#b5651d",
                color: "#b5651d",
                fontWeight: 600,
                textTransform: "uppercase",
                "&:hover": {
                  backgroundColor: "#b5651d",
                  color: "#fff",
                  borderColor: "#b5651d",
                },
              }}
            >
              Download Brochure
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProjectsSection;
